// Broker-live API client.
//
// Browser code never talks to IBKR directly. These helpers consume the DRF
// broker-live contract under /api/v1/ibkr/live/ and leave all broker sessions,
// tokens, and adapter details on the backend.

import axiosClient from './axiosClient.js';

const LIVE_BASE = '/ibkr/live';
const SILENT_CONFIG = { skipGlobalErrorHandler: true };

const getLive = async (path, config = {}) => {
  const { data } = await axiosClient.get(`${LIVE_BASE}${path}`, { ...SILENT_CONFIG, ...config });
  return data;
};

const postLive = async (path, body = {}, config = {}) => {
  const { data } = await axiosClient.post(`${LIVE_BASE}${path}`, body, { ...SILENT_CONFIG, ...config });
  return data;
};

export const getBrokerLiveConnection = () => getLive('/connection/');

export const getBrokerLivePositions = () => getLive('/positions/');

export const refreshBrokerLivePositions = () => postLive('/refresh/');

export const getBrokerLiveAccountState = () => getLive('/account-state/');

export const getBrokerLiveAccountStateStatus = () => getLive('/account-state/status/');

export const getBrokerLiveRecentExecutions = () => getLive('/executions/recent/');

export const getBrokerLiveExecutionsStatus = () => getLive('/executions/status/');

export const refreshBrokerLiveExecutions = () => postLive('/executions/refresh/');

export const getBrokerLiveSyncStatus = () => getLive('/sync-status/');

export default {
  getBrokerLiveConnection,
  getBrokerLivePositions,
  refreshBrokerLivePositions,
  getBrokerLiveAccountState,
  getBrokerLiveAccountStateStatus,
  getBrokerLiveRecentExecutions,
  getBrokerLiveExecutionsStatus,
  refreshBrokerLiveExecutions,
  getBrokerLiveSyncStatus,
};
